@if (text) {
  <span [matTooltip]="tooltipText" [matTooltipDisabled]="!isTruncated">
    {{ text | middleEllipsis:maxLength }}
  </span>
}
